export class BOOKING_TYPE_TAG {
  static AwaitsConfirmation = 'BOOKING_TYPE:AWAITS_CONFIRMATION';
  static WalkIn = 'BOOKING_TYPE:WALK_IN';
  static Ended = 'BOOKING_TYPE:ENDED';

  static nameof(bookingTag) {
    switch (bookingTag) {
      case BOOKING_TYPE_TAG.AwaitsConfirmation: {
        return 'Awaits confirmation';
      }
      case BOOKING_TYPE_TAG.WalkIn: {
        return 'Walk-in';
      }
      case BOOKING_TYPE_TAG.Ended: {
        return 'Ended';
      }
    }
  }

  static colorof(bookingTag) {
    switch (bookingTag) {
      case BOOKING_TYPE_TAG.AwaitsConfirmation: {
        return '#a7a748';
      }
      case BOOKING_TYPE_TAG.WalkIn: {
        return 'purple';
      }
      case BOOKING_TYPE_TAG.Ended: {
        return 'red';
      }
    }
  }

  static iconof(bookingTag) {
    switch (bookingTag) {
      case BOOKING_TYPE_TAG.AwaitsConfirmation: {
        return 'AlertCircleIcon';
      }
      case BOOKING_TYPE_TAG.Ended: {
        return 'XCircleIcon';
      }
    }
  }
}
